export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

export const APP_CONFIG = {
  apiBaseUrl: API_BASE_URL,
  stripePublishableKey: STRIPE_PUBLISHABLE_KEY,
  routes: {
    member: {
      dashboard: '/member/dashboard',
      plans: '/member/plans',
      subscriptions: '/member/subscriptions',
    },
    business: {
      dashboard: '/business/dashboard',
      plans: '/business/plans',
      subscriptions: '/business/subscriptions',
    },
  },
}; 